export default class AudioDecoder {
  constructor() {
    this.worker = new Worker("./audio-processing/opus_decoder_worker.js");
  }

  setup(config) {
    var _this = this;
    return new Promise(function(resolve, reject) {
      _this.worker.onmessage = function(ev) {
        if (ev.data.status !== 0) {
          reject(ev.data);
          return;
        }
        resolve(ev.data);
      };
      _this.worker.postMessage({
        command: "setup",
        config
      });
    });
  }

  decode(packet) {
    var _this = this;
    return new Promise(function(resolve, reject) {
      _this.worker.onmessage = function(ev) {
        if (ev.data.status !== 0) {
          reject(ev.data);
          return;
        }
        resolve(ev.data);
      };
      _this.worker.postMessage({ command: "decode", packet });
    });
  }
}
